import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthGuard } from '../../services/auth/auth.guard';
import { OfferService } from '../../services/offer.service';

@Injectable()
export class OffersCountResolve implements Resolve<any> {
  constructor(private offerService: OfferService, private authGuard: AuthGuard) {}

  resolve(route: ActivatedRouteSnapshot): Observable<number> {
    return this.offerService.getCount(this.authGuard.userId, this.authGuard.userId, '', '', null, null, '');
  }
}
